/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { ButtonHTMLAttributes, FC, ReactNode } from 'react'
import { rpMediaQueries } from '../../core/theme'
import { Typography } from '../Typography'

interface BlackSilverBtnProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string
  className?: string
  fullWidth?: boolean
  icon?: ReactNode
}

const BlackSilverBtn: FC<BlackSilverBtnProps> = ({
  text,
  className,
  fullWidth = false,
  icon,
  ...rest
}) => {
  return (
    <button
      {...rest}
      className={className}
      type="button"
      css={css`
        all: unset;
        cursor: pointer;
        border-radius: 15px;
        padding: 4px 6px;
        ${fullWidth && 'width: 100%;'}
        background: linear-gradient(
          96deg,
          rgba(213, 213, 213, 0) 0.84%,
          rgba(204, 204, 204, 0.2) 43.19%,
          rgba(49, 49, 49, 0.2) 87.63%
        );
        box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05),
          0 4px 4px 0 rgba(0, 0, 0, 0.05), 0 10px 10px 0 rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(10px);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1px;
        border: 1px solid rgba(255, 255, 255, 0.07);
        transition: all 0.2s ease-in-out;

        &:hover {
          background: linear-gradient(
            96deg,
            rgba(213, 213, 213, 0.1) 0.84%,
            rgba(204, 204, 204, 0.35) 43.19%,
            rgba(49, 49, 49, 0.35) 87.63%
          );
          border-color: rgba(255, 255, 255, 0.15);
          box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05),
            0 4px 4px 0 rgba(0, 0, 0, 0.05), 0 10px 10px 0 rgba(0, 0, 0, 0.1),
            0 0 12px 0 rgba(255, 255, 255, 0.2);
        }

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        ${rpMediaQueries.tablet} {
          padding: 7px 11px;
        }
      `}>
      {icon && (
        <span
          css={css`
            display: inline-flex;
            align-items: center;
          `}>
          {icon}
        </span>
      )}
      <Typography variant="buttonLittle" color="white" as="span">
        {text}
      </Typography>
    </button>
  )
}

export default BlackSilverBtn
